(function () {
  'use strict';

  var TIME_ZONE = 'Europe/Paris';
  var WEEKDAYS = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

  function getParisNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TIME_ZONE,
      weekday: 'short',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(new Date());

    var values = {};
    parts.forEach(function (part) {
      values[part.type] = part.value;
    });

    var weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

    return {
      year: Number(values.year),
      month: Number(values.month),
      day: Number(values.day),
      weekday: weekdayMap[values.weekday],
      hour: Number(values.hour),
      minute: Number(values.minute)
    };
  }

  function addDays(parts, days) {
    var date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + days));
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate(),
      weekday: date.getUTCDay()
    };
  }

  function beforeOrAtCutoff(now) {
    return now.hour < 22 || (now.hour === 22 && now.minute === 0);
  }

 function calculateDelivery() {
  var now = getParisNow();
  var delivery;
  var detail = '订单将按最近可用配送日自动安排。';

  if (now.weekday === 1) {
    // 周一：22:00前周二，22:00后周四
    if (beforeOrAtCutoff(now)) {
      delivery = addDays(now, 1);
    } else {
      delivery = addDays(now, 3);
      detail = '已超过周一22:00截单时间，订单将顺延至周四。';
    }

  } else if (now.weekday === 2) {
    // 周二：周四配送
    delivery = addDays(now, 2);

  } else if (now.weekday === 3) {
    // 周三：22:00前周四，22:00后周六
    if (beforeOrAtCutoff(now)) {
      delivery = addDays(now, 1);
    } else {
      delivery = addDays(now, 3);
      detail = '已超过周三22:00截单时间，订单将顺延至周六。';
    }

  } else if (now.weekday === 4) {
    // 周四：周六配送
    delivery = addDays(now, 2);

  } else if (now.weekday === 5) {
    // 周五：22:00前周六，22:00后下周二
    if (beforeOrAtCutoff(now)) {
      delivery = addDays(now, 1);
    } else {
      delivery = addDays(now, 4);
      detail = '已超过周五22:00截单时间，订单将顺延至下周二。';
    }

  } else if (now.weekday === 6) {
    // 周六：下周二配送
    delivery = addDays(now, 3);

  } else {
    // 周日：下周二配送
    delivery = addDays(now, 2);
    detail = '周日订单将按下周二配送安排。';
  }

  return {
    text:
      WEEKDAYS[delivery.weekday] +
      ' ' +
      delivery.month +
      '月' +
      delivery.day +
      '日｜11:00–21:00',

    value:
      delivery.year +
      '-' +
      String(delivery.month).padStart(2, '0') +
      '-' +
      String(delivery.day).padStart(2, '0') +
      ' 11:00–21:00 Europe/Paris',

    detail: detail
  };
}


  function updateDeliveryNotice() {
    var notices = document.querySelectorAll('[data-tonglinji-delivery]');
    if (!notices.length) return;

    var result = calculateDelivery();

    notices.forEach(function (notice) {
      var dateNode = notice.querySelector('[data-tonglinji-delivery-date]');
      var detailNode = notice.querySelector('[data-tonglinji-delivery-detail]');
      var inputNode = notice.querySelector('[data-tonglinji-delivery-input]');

      if (dateNode) dateNode.textContent = result.text;
      if (detailNode) detailNode.textContent = result.detail;
      if (inputNode) inputNode.value = result.value;
    });
  }

  function start() {
    updateDeliveryNotice();
    // Horizon购物车抽屉动态加载；低频检查新出现的提示框，不监听整个DOM变化。
    window.setInterval(updateDeliveryNotice, 1500);
    document.addEventListener('cart:refresh', updateDeliveryNotice);
    document.addEventListener('cart:updated', updateDeliveryNotice);
    document.addEventListener('shopify:section:load', updateDeliveryNotice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
